module.exports = __webpack_public_path__ + "static/img/68-3.ac2fccf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/68-3.jpg
// module id = Hcn2
// module chunks = 0